import { Alert, Button, Flex, Input, Spin, Table, TableColumnsType, Tabs, Typography } from "antd";
import { Tab } from "rc-tabs/lib/interface";
import { DataMapping, useGetDataMappingsQuery, useGetVendorsQuery } from "../../../api/dataMapping/dataMappingApi";
import { useEffect, useState } from "react";
import ManageMappingModal from "./ManageMappingModal";
import { PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { skipToken } from "@reduxjs/toolkit/query";

export default function ManageMappingPage() {
  const [pagedData, setPagedData] = useState<DataMapping[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  // const [search, setSearch] = useState("");  // avoid firing search on type
  const [pageKey, setPageKey] = useState<string | null>(null);
  const [vendorId, setVendorId] = useState<string | undefined>();
  const { data: vData, error: vError, isFetching: vIsFetching,
          refetch: vRefetch } = useGetVendorsQuery();
  const { data, error, isFetching, refetch } = useGetDataMappingsQuery(
    vendorId !== undefined ? { vendorId, after: pageKey, /* search */ } : skipToken
  );
  const [detailModal, setDetailModal] = useState<DataMapping | null>(null);
  const [isCreating, setIsCreating] = useState(false);

  useEffect(() => {
    console.log("vdata updated", vData);
    if (vData && vData.length > 0 && vendorId === undefined) {
      console.log("resetting vendor ID");
      setVendorId(vData[0]);
    }
  }, [vData]);

  useEffect(() => {
    setPageKey(null);
  }, [vendorId]);

  /*
   * Auto-trigger load more
   */
  useEffect(() => {
    if (data?.LastEvaluatedKey !== undefined) {
      console.log("loading more")
      handleLoadMore();
    }
  }, [data]);

  useEffect(() => {
    if (pageKey !== null && data !== undefined) {
      const toAdd = data.Items.filter(d =>
        !pagedData.map(p => p.Id).includes(d.Id)
      );
      setPagedData(pagedData.concat(toAdd));
    } else if (pageKey === null && data !== undefined) {
      setPagedData(data.Items);
    } else {
      setPagedData([]);
    }
  }, [pageKey, data]);

  const columns: TableColumnsType<DataMapping> = [
    {
      title: "Title",
      dataIndex: ["ItemDetails", "Title"],
      key: "ItemDetails.Title",

    },
    {
      title: "Internal Code",
      dataIndex: "InternalSku",
      key: "InternalSku",
    },
    {
      title: "Provider Code",
      dataIndex: "VendorSku",
      key: "VendorSku",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="dashed" onClick={() => setDetailModal(record)}>
          Details
        </Button>
      ),
    }
  ]

  const clSearchPageData = pagedData.filter(x =>
    (x.InternalSku?.toLowerCase()?.includes(searchQuery.toLowerCase()) ?? false)
    || (x.VendorSku?.toLowerCase()?.includes(searchQuery.toLowerCase()) ?? false)
    || (x.ItemDetails?.Title?.toLowerCase()?.includes(searchQuery.toLowerCase()) ?? false)
  );

  const tabItems: Tab[] = vData?.map(v => ({
    label: v,
    key: v,
    closable: false,
    destroyInactiveTabPane: true,
    children: (
      <Table
        dataSource={clSearchPageData}
        columns={columns}
        loading={isFetching}
        rowKey="Id"
      />
    )
  })) ?? []

  function handleTabChange(key: string) {
    // setSearch("");
    setSearchQuery("");
    setVendorId(key);
  }

  function handleLoadMore() {
    if (data?.LastEvaluatedKey === undefined) {
      return;
    }
    setPageKey(data.LastEvaluatedKey.Id);
  }

  function handleSearch() {
    // setSearch(searchQuery);
  }

  // const canLoadMore = data?.LastEvaluatedKey !== undefined;

  return (<>
    <Flex vertical gap={8}>
      <Typography.Title level={2}>Manage Mappings</Typography.Title>
      <Input.Search
        placeholder={`Search ${vendorId ?? "this vendor"} by title, internal code, provider code`}
        enterButton="Search"
        value={searchQuery}
        onChange={e => setSearchQuery(e.target.value)}
        onSearch={handleSearch}
      />
      <Flex justify="space-between" align="center">
        <Flex align="center">
          <Typography.Text>
            {data && !isFetching && !error
              ? `${clSearchPageData.length} record${clSearchPageData.length !== 1 ? "s" : ""} found`
              : ""
            }
          </Typography.Text>
          {/* {data && !isFetching && canLoadMore &&
            <Button type="link" onClick={handleLoadMore}>Load More</Button>
          } */}
        </Flex>
        <Flex gap={8}>
          <Button icon={<PlusOutlined />} onClick={() => setIsCreating(true)} />
          <Button icon={<ReloadOutlined />} onClick={refetch} />
        </Flex>
      </Flex>
      { vError &&
        <Alert
          message="Error loading data"
          description="There was an error loading vendor data from mappings"
          type="error"
          showIcon
          action={
            <Button danger onClick={vRefetch}>
              Try Again
            </Button>
          }
        />
      }
      { (error && !vError) &&
        <Alert
          message="Error loading data"
          description="There was an error loading data mappings"
          type="error"
          showIcon
          action={
            <Button danger onClick={refetch}>
              Try Again
            </Button>
          }
        />
      }
      { vIsFetching && <Spin /> }
      <Tabs
        activeKey={vendorId}
        onChange={handleTabChange}
        items={tabItems}
      />
    </Flex>
    {(detailModal || isCreating) && (
      <ManageMappingModal
        m={detailModal}
        open={!!detailModal || isCreating}
        onOk={() => {
          setDetailModal(null);
          setIsCreating(false);
          refetch();
        }}
        onCancel={() => {
          setDetailModal(null);
          setIsCreating(false);
        }}
      />
    )}
  </>)
}